import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { accessadmin } from "../../lib/api";
import OTPInput from "../otp/OTPInput";

export default function AdminAccess() {
  let navigate = useNavigate();
  const [splash, setSplash] = useState(true);
  const [otperror, setotperror] = useState(false);
  const [otpsubmiting, setotpsubmiting] = useState(false);
  const [otpvalue, setotpValue] = useState("");
  const [phone, setPhone] = useState("");
  const [{ otp, numInputs }, setConfig] = useState({
    otp: "",
    numInputs: 6,
  });






  const fetchPatient = async () => {

    if (sessionStorage.getItem("patientPhone")) {
      setPhone(sessionStorage.getItem("patientPhone"));
    }
    if (localStorage.getItem("patientId")) {
      setSplash(false);
    } else {
      setSplash(false);
    }
  };

  useEffect(() => {
    fetchPatient();
  }, []);

  const handleOTPChange = (otp) => {
    setConfig((prevConfig) => ({ ...prevConfig, otp }));
    // console.log(otp, "handle change");
    setotpValue(otp);
    if (otp.length == numInputs) {
      handleOTPComplete(otp);
    }
  };

  const clearOtp = () => {
    setConfig((prevConfig) => ({ ...prevConfig, otp: "" }));
  };



  const confirmOtp = async (otp) => {
    if (otp != "") {
      setotpsubmiting(true);
      var id = localStorage.getItem("patientId");
      let data;
      
         data = await accessadmin({
          "source": {
              "identifier": "654cc54350349ba664618567",
              "location": "",
              "name": "",
              "classification": "webapp"
          },
          "passcode": otp
        });
      console.log(data);
      console.log(data?.data?.data?.result?.token);
      if (data?.data?.data?.result?.token) {
        console.log(data?.data?.token);
        sessionStorage.setItem("adminAccessToken", data?.data?.data?.result?.token);
        navigate("/admin");
      } 
      // else if (otp == "912864") {
      //   navigate("/admin");
      // }
       else {
        setotperror(true);

        setotpsubmiting(false);
      }
    }
  };
  const handleOTPComplete = (otp) => {
    // Handle the completed OTP here, e.g., make an API request

    setotperror(false);
    console.log("Completed OTP:", otp);
    setotpValue(otp);
    confirmOtp(otp);
  };

  return (
    <>
      {splash == true && (
        <div className="bg-white absolute h-screen w-full z-50 flex  flex-col">
          <div className="flex-1"></div>
          <div>
            {" "}
            <img src="Loading_prog.gif" alt='prog' className="h-24 mx-auto" />
          </div>
          <div className="flex-1"></div>
        </div>
      )}
      <div className="bg-primary text-white   relative  flex flex-col dh-screen">
        <div className="z-20 relative px-6 py-4 h-[260px] sm:w-3/5 ">
          <div className="flex w-full">
            <div className="flex-1 mt-4 mx-auto">
              <img src="../../../images/Logo.svg" alt='logo' className="mb-8" />
            </div>
          </div>

          <div className="text-2xl text-left font-semibold mb-8">
            <>
              <span className="text-4xl">Access code</span> <br />
              Verification
            </>
          </div>
        </div>
        <div className="overflow-hidden bg-white w-full pb-6 rounded-t-2xl flex flex-col sm:w-3/5 mx-auto text-black flex-1 justify-between">
          <div className="flex flex-col  pt-4 mx-4 flex-1">
            <div className="w-[260px] text-slate-700 text-xl font-bold pt-6">
              Enter Access code.
            </div>

            <div className="flex  pt-6">
              <OTPInput
                inputStyle="inputStyle"
                numInputs={numInputs}
                onChange={handleOTPChange}
                value={otp}
                renderInput={(props) => <input {...props} />}
                shouldAutoFocus
              />
              <div />
            </div>
            {otperror && (
              <div className="pt-2 text-red-600 text-lg">Invalid Access code</div>
            )}
            {otpsubmiting && (
              <div className="pt-2 text-blue-700 font-bold text-xl">
                Verifying...
              </div>
            )}

          </div>

          <div className="px-2">
            <button
              disabled={otp.length < numInputs}
              className="w-full rounded-2xl border-4 border-primary bg-primary p-3 text-white  text-lg mt-4 font-bold"
              onClick={() => confirmOtp(otpvalue)}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
     
    </>
  );
}
